// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610191122/js/" + chunkId + "." + {"44":"f2011f99","225":"8ff3eae0","481":"a7d87046","486":"5551198d","770":"67b9085f"}[chunkId] + ".0.8227255692313513.chunk.js";
};